import { JSX } from 'react';
import { Layout, CheckForApplicationUpdate } from 'react-admin';
import AdminMenu from '../menu/AdminMenu';
import { NokNokAppBar } from "../menu/NokNokAppBar";
import { useThemeAttribute } from "../global-hooks/use-theme-attribute";
import { ChatFormBridgeProvider } from "../chat-bot/context/ChatFormBridge";
import { MaintenanceBanner } from "../maintenance/MaintenanceBanner";

export const AdminLayout = (props: any): JSX.Element => {
    // Publishes the active palette mode to the document element so the
    // hand-written stylesheets can follow light/dark like the MUI components do.
    useThemeAttribute();

    // Above both the app bar, which renders the assistant, and the page, which renders the form.
    // They are siblings, so this is the only place the two can be introduced to each other.
    return (
        <ChatFormBridgeProvider>
            <Layout {...props} menu={ AdminMenu } appBar={ NokNokAppBar }>
                { /* Above every screen, so a maintenance window is never news to an admin. */ }
                <MaintenanceBanner />
                { props.children }
                <CheckForApplicationUpdate disabled={true} />
            </Layout>
        </ChatFormBridgeProvider>
    );
};
